exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-card.in-card {\n  margin-top: 3px;\n  margin-bottom: 3px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.in-card .el-col {\n  padding-left: 3px;\n  padding-right: 3px;\n}\ndiv.option {\n  padding: 3px;\n  border-bottom: 1px solid seagreen;\n}\ndiv.quoted {\n  font-size: 11px;\n  font-style: italic;\n}\ndiv.option div.main {\n  font-weight: bold;\n}\n", ""]);

// exports
